import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="w-full bg-gradient-to-br from-background-100 via-background-50 to-secondary-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs tracking-wide">
            <i className="ri-award-line"></i>
            演员资料库 · OGURA YUKO
          </span>

          <h1 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 mt-6">
            小仓优子
            <span className="block text-primary-600 mt-2">每一个角色，都值得被认真对待</span>
          </h1>

          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mt-6 max-w-xl">
            从初登荧幕的青涩，到如今从容笃定的实力派，她以细腻自然的表演塑造了一个个令人难忘的角色。这里收录了她的完整影视作品、最新动态与个人资料，带你走近最真实的小仓优子。
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-8">
            <Link
              to="/category/works"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer text-center whitespace-nowrap"
            >
              浏览影视作品
            </Link>
            <Link
              to="/profile"
              className="px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer text-center whitespace-nowrap"
            >
              查看个人简介
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-10 pt-8 border-t border-background-200 max-w-lg">
            <div>
              <div className="font-heading text-2xl md:text-3xl text-primary-600">30+</div>
              <div className="text-xs text-foreground-500 mt-1">影视作品</div>
            </div>
            <div>
              <div className="font-heading text-2xl md:text-3xl text-primary-600">2015</div>
              <div className="text-xs text-foreground-500 mt-1">出道年份</div>
            </div>
            <div>
              <div className="font-heading text-2xl md:text-3xl text-primary-600">10+</div>
              <div className="text-xs text-foreground-500 mt-1">奖项提名</div>
            </div>
          </div>
        </div>

        <div className="relative animate-fade-up">
          <div className="absolute -inset-4 rounded-[2rem] bg-accent-100/50 -z-0"></div>
          <div className="relative w-full aspect-[4/5] rounded-[1.5rem] overflow-hidden border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20a%20young%20East%20Asian%20actress%20in%20a%20refined%20deep%20wine%20red%20coat%20standing%20against%20a%20warm%20cream%20studio%20background%2C%20soft%20directional%20lighting%20with%20gentle%20shadows%2C%20calm%20confident%20expression%2C%20high%20fashion%20magazine%20aesthetic%2C%20high%20detail&width=900&height=1100&seq=ogura-hero-main&orientation=portrait"
              alt="小仓优子主视觉写真"
              title="小仓优子 演员资料库 主视觉"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute bottom-6 -left-2 md:left-6 bg-background-50 rounded-lg border border-secondary-200 px-4 py-3 shadow-none">
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-secondary-500"></i>
              <span className="text-sm text-foreground-800">最新电影《星夜之约》</span>
            </div>
            <div className="text-xs text-foreground-500 mt-1">2024 · 奇幻爱情 · 主演</div>
          </div>
        </div>
      </div>
    </section>
  );
}